import React from "react";
import * as S from "./styled";
import PT from "prop-types";
// import Specs from "./Specs";
import Services from "./Services";
import Features from "./Features";
import Steps from "./Steps";
import SEO from "./seo";
import { useTranslation } from "react-i18next";
import { LinkGenerator } from "@/utils/LinkGenerator";
import { PARTNERS_NS } from "@/i18n/ns";
import { FullScreenSpin as Spin } from "_c/preloader";
import { useHistory } from "react-router-dom";
import { analyticsAction } from "@/utils/analytics";
import { Button } from "_c/button";
import BrowserOnly from "@/components/BrowserOnly";
import AppLinks from "./AppLinks";

const PartnersPage = (props) => {
  const history = useHistory();
  const { t, ready } = useTranslation([PARTNERS_NS, "common"], {
    useSuspense: false,
  });
  const { isMaster, isAuth, openAuthModal } = props;
  const onProfileClick = () => {
    if (isAuth) {
      analyticsAction({
        category: "partners",
        action: "launch_planner_auth",
      });
      history.push(
        isMaster
          ? LinkGenerator.masterSchedule()
          : LinkGenerator.clientProfile()
      );
    } else {
      analyticsAction({
        category: "click",
        action: "create_acc",
      });
      openAuthModal();
    }
  };
  const transPrefix = isAuth ? "_auth" : "";
  const onEducationClick = () => {
    if (!isAuth) {
      analyticsAction({
        category: "button",
        action: "watch_video_partners",
      });
    }
  };
  if (!ready) return <Spin size="xl" />;
  return (
    <S.Wrap>
      <SEO t={t} />
      <S.Header>
        <S.Hero>
          <h1>{t(`titles.1${transPrefix}`)}</h1>
          <p>{t(`subtitles.1${transPrefix}`)}</p>
          <S.HeroButtons>
            <Button onClick={onProfileClick} greenish>
              {t(`buttons.${isAuth ? "profile" : "register"}`)}
            </Button>
            <Button
              target="_blank"
              as="a"
              onClick={onEducationClick}
              href={
                isAuth
                  ? LinkGenerator.help(props.locale)
                  : "https://www.instagram.com/tv/CXGvbxUr1T-"
              }
            >
              {t("buttons.premium")}
            </Button>
          </S.HeroButtons>
          <BrowserOnly>
            <AppLinks t={t} />
          </BrowserOnly>
        </S.Hero>
      </S.Header>
      <S.ContentWrap>
        {/*<Specs t={t} />*/}
        <Services t={t} />
        <Features t={t} />
        <Steps t={t} openAuthModal={openAuthModal} isAuth={isAuth} />
      </S.ContentWrap>
    </S.Wrap>
  );
};
PartnersPage.propTypes = {
  isAuth: PT.bool,
  isMaster: PT.bool,
  specs: PT.array,
  locale: PT.string,

  openAuthModal: PT.func,
};

export default PartnersPage;
